/**
 * Name: Burger
 */

import Collapsible from "@lunaweb/vega-reactor-js/src/patterns/Collapsible";

export default class Burger extends Collapsible {
  static settings = {
    control: '.js-burger-control',
    target: '.js-burger-target',
  };

  constructor(element, options = {}) {
    super(element, {
      ...Burger.settings,
      ...options,
    });
    this.header = document.querySelector('header');
    this.html = document.documentElement;
  }

  get isDisplayed() {
    return getComputedStyle(this.element).display !== 'none';
  }

  open() {
    super.open();
    if (this.isDisplayed) {
      this._toggleHeaderOpen(true);
    }
  }

  close() {
    super.close();
    this._toggleHeaderOpen(false);
  }

  mount() {
    if (!this.isMounted) {
      super.mount();
      this.target.classList.add('has-burger');
      this.target.setAttribute('tabindex', '-1');
      this._toggleHeaderOpen(false);
    }
  }

  unmount() {
    if (this.isMounted) {
      super.unmount();
      this.target.classList.remove('has-burger');
      this.target.removeAttribute('tabindex');
      this._toggleHeaderOpen(false);
    }
  }

  _toggleHeaderOpen(add) {
    if (!this.header) return;

    if (add) {
      this._hadDarkClass = this.header.classList.contains('c-header--dark');
      if (this._hadDarkClass) {
        this.header.classList.remove('c-header--dark');
      }
    } else if (this._hadDarkClass) {
      this.header.classList.add('c-header--dark');
    }

    this.header.classList[add ? 'add' : 'remove']('is-open');
    this.html.classList[add ? 'add' : 'remove']('no-scroll');
  }
}
